import { useCallback, useState } from 'react'

export interface PlansCoveragesDates {
  planId: string;
  coverageEndDate?: string;
  lastDayToSubmitClaim?: string;
}

export const usePlanCoveragesDates = () => {
  const [plansCoveragesDates, setPlansCoveragesDates] = useState<PlansCoveragesDates[]>([]);

  const getPlanCoveragesClaimDate = useCallback((planId: string) => {
      const planCoverage = plansCoveragesDates.find((item) => item.planId === planId);
      return planCoverage?.lastDayToSubmitClaim || '';
    }, [plansCoveragesDates]);
  
  const getPlanCoveragesEndDate = useCallback((planId: string) => {
    const planCoverage = plansCoveragesDates.find((item) => item.planId === planId);
    return planCoverage?.coverageEndDate || '';
  }, [plansCoveragesDates]);
  
  const setPlanCoveragesEndDate = useCallback((planId: string, date: string) => {
    setPlansCoveragesDates((prev) => {
      const existingPlan = prev.find((item) => item.planId === planId);
      if (existingPlan) {
        return prev.map((item) =>
          item.planId === planId ? { ...item, coverageEndDate: date } : item
        );
      }
      return [...prev, { planId, coverageEndDate: date }];
    });
  }, []);
  
  const setPlanCoveragesClaimDate = useCallback((planId: string, date: string) => {
    setPlansCoveragesDates((prev) => {
      const existingPlan = prev.find((item) => item.planId === planId);
      if (existingPlan) {
        return prev.map((item) =>
          item.planId === planId ? { ...item, lastDayToSubmitClaim: date } : item
        );
      }
      return [...prev, { planId, lastDayToSubmitClaim: date }];
    });
  }, []);

  return {
    plansCoveragesDates,
    getPlanCoveragesClaimDate,
    getPlanCoveragesEndDate,
    setPlanCoveragesEndDate,
    setPlanCoveragesClaimDate,
    setPlansCoveragesDates,
  }
}
